
const PageHome = () => 
{
    window.location.href = '/novidades';
    return null;
}

export default PageHome;